import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';

import {BrokenLinkIcon} from '@fo/root/designSystem/atoms/Icons';
import Button, {ButtonVariant} from '@fo/designSystem/Buttons/Button/Button';
import InformationBox from '@fo/designSystem/InformationBox/InformationBox';
import BaseModal from '@fo/designSystem/BaseModal/BaseModal';
import {fonts} from '@fo/shared/styles/variables';
import Headers, {HeaderType} from '@fo/designSystem/Text/Headers/Headers';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';

function IdentityErrorsModal(): ReactElement {
  const {formatMessage} = useIntl();

  return (
    <BaseModal>
      {(onClose) => (
        <div className="identityErrorModal" id="identityErrorModal" data-testid="modal.identityError">
          <BrokenLinkIcon />
          <Headers headerType={HeaderType.H3} alignment={fonts.alignment.CENTER}>
            <FormattedMessage id="identity.errors.modal.title.v2" />
          </Headers>
          <Paragraph alignment={fonts.alignment.CENTER}>
            <FormattedMessage id="identity.errors.modal.copy.v2" />
          </Paragraph>
          <InformationBox
            title={formatMessage({id: 'identity.errors.modal.error.title'})}
            copy={<FormattedMessage id="identity.errors.modal.error.copy.v2" />}
            hasBorder
          >
            <Button
              id="identityErrorsModalClose"
              type="button"
              ariaLabel={formatMessage({id: 'identity.errors.modal.button'})}
              variant={ButtonVariant.PRIMARY}
              onClick={onClose}
            >
              <FormattedMessage id="identity.errors.modal.button" />
            </Button>
          </InformationBox>
        </div>
      )}
    </BaseModal>
  );
}

export default IdentityErrorsModal;
